var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('transition',{attrs:{"name":"fade"}},[_c('div',{attrs:{"id":"mask"},on:{"!click":function($event){_vm.closeLayer2($event)}}},[_c('div',{staticClass:"center-content"},[_c('i',{staticClass:"el-icon-close close",on:{"click":_vm.closeLayer}}),_vm._v(" "),_vm._t("default")],2)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03a8adcb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MaskLayer/index.vue
// module id = null
// module chunks = 